<modal #modal>
    <div class="modal-header welcome-header">
        <div class="col-12">
            <h4>Du nåede desværre ikke at deltage i denne månedstrækning</h4>
        </div>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCloseClick()">
            
        </button>
    </div>
    <div class="modal-body">
        <p>
            Du har desværre overskredet tidsgrænsen for kortbetaling til denne månedstrækning.
        </p>
    </div>
</modal>
